import {useChangeStore} from '../../change';
import type {GridEditor, Permissions} from '../../../types';
import {
	breakItUp,
	getColumnsFromGrid,
	getColumnsByName,
	getDataFromGrid,
	getUpdatedValueData,
} from '../../../utils';

import {FormValues} from '@netx/core-components/Form';

export default async function specific(
	gridEditor: GridEditor,
	values: FormValues[],
	initialValues: FormValues[],
	changeStore: ReturnType<typeof useChangeStore>,
	permissions: Permissions,
	progress?: (progress: number) => void,
) {
	if (process.env.NODE_ENV === 'development') {
		console.time('set-values/specific');
	}

	const {round} = Math;

	const data = getDataFromGrid(gridEditor);
	const columns = getColumnsFromGrid(gridEditor);
	const columnsByName = getColumnsByName(columns);
	const size = values.length;

	const amount = size <= 10 ? 1 : 10;

	await breakItUp(
		{
			amount,
			size,
		},
		(index) => {
			progress && progress(round(((index + 1) / size) * 100));

			const updateData = values[index];
			const {assetId} = updateData;

			const rowData = data.find((d) => d.assetId === assetId);
			if (!rowData) return;

			const perms = permissions[assetId];

			for (const field in updateData) {
				const column = columnsByName[field];
				if (!column || (perms && perms.includes(field))) continue;

				const {name} = column;

				const valueData = getUpdatedValueData(
					assetId,
					updateData,
					rowData,
					initialValues,
					column,
				);
				if (!valueData) continue;

				valueData.changed
					? changeStore.add(assetId, name)
					: changeStore.remove(assetId, name);

				rowData[field] = valueData.value;
			}
		},
	);

	gridEditor.repaint();

	progress && progress(100);

	if (process.env.NODE_ENV === 'development') {
		console.timeEnd('set-values/specific');
	}
}
